import LabServiceModel from "@/models/LabServiceModel";
import SubmissionModel from "./SubmissionModel";
import SubmissionStatusModel from "./SubmissionStatusModel";

export default class SubmissionStatusLogModel extends LabServiceModel {

  modelName() {
    return 'submission-status-log';
  }

  defaults() {
    return {
      id: null,
      submission_id: null,
      submission: null,
      submission_status_id: null,
      submission_status: null,
      start_date: null,
      end_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      submission_id: (val) => (this.nullStringMutator(val)),
      submission_status_id: (val) => (this.nullStringMutator(val)),
      start_date: (val) => (this.nullStringMutator(val)),
      end_date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getSubmission() {
    return this.getRelatedModel(SubmissionModel, 'submission');
  }

  getSubmissionStatus() {
    return this.getRelatedModel(SubmissionStatusModel, 'submission_status');
  }

}
